import React from 'react';

// TODO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! 
// this is duplicated in the cms-generator use caution if updating
export enum Viewport {
    DESKTOP,
    TABLET,
    MOBILE,
}
/////////////////////////////////////////////////////////// 

export const getViewportForWidth = (width: number): Viewport => {
    if (width < 768) {
        return Viewport.MOBILE;
    } else if (width > 1024) {
        return  Viewport.DESKTOP;
    } else {
        return Viewport.TABLET;
    }
}

export const useViewport = (userAgent?): Viewport => {

    const defaultViewport = React.useMemo(() => {
        let width = 1366;
        if (userAgent?.match(/Tablet|iPad/i)) {
            width = 1024;
        } else if (userAgent?.match(/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry/i)) {
            width = 767;
        }
        const viewport = getViewportForWidth(width);
        return viewport;
    }, [userAgent])

    const [viewport, setViewport] = React.useState(defaultViewport);

    const getWindowDims = () => {
        const widths = [];
        window.innerWidth && widths.push(window.innerWidth);
        if (window.screen?.width) {
            widths.push(window.screen?.width);
        }
        return {
            width: widths.length > 0 && Math.min(...widths),
        }
    }
  
    const getWindowSize = () => {
        const dims = getWindowDims();
        const viewport = getViewportForWidth(dims.width);
        return viewport;
    }

    React.useEffect(() => {
        let timeoutId = null;
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                setViewport(getWindowSize());
            }, 20);
        }
        setViewport(getWindowSize());
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        }
    }, []);

    return viewport;
}
